module.exports = __webpack_public_path__ + "img/84b9bdb.jpg";